<div class="ml-1 pt-5 auth-background">
  <div class="form-row">
    <div class="col-12 col-md-6 offset-md-3 pt-3">
      <div id="login-box" class="card">
        <div class="ml-2 mt-3">
          <img
            src="./assets/img/mopc-v2.png"
            alt="Logo Obras Públicas"
            width="260px"
            loading="lazy"
          />
        </div>
        <h5 style="margin-bottom: 0" class="card-header">
          Sorteo de Obras Viales y de Edificaciones en Distintas Provincias
        </h5>
        <span
          class="ml-3"
          style="color: red; font-size: xx-small; font-weight: bold"
          *ngIf="env.Staging"
        >
          AMBIENTE DE PRUEBA
        </span>
        <div class="card-body">
          <form>
            <div class="form-group">
              <p for="username">Rnc/Cédula</p>
              <input
                type="text"
                name="email"
                class="form-control"
                [(ngModel)]="userName"
              />
            </div>
            <div class="form-group">
              <p for="password">Contraseña</p>
              <input
                type="password"
                name="password"
                class="form-control"
                [(ngModel)]="password"
              />
            </div>
            <button class="col-12 col-lg-4 btn btn-primary" (click)="login()">
              Iniciar Sesión
            </button>
            <button
              class="col-12 col-lg-6 btn btn-secondary float-right"
              routerLink="/home"
            >
              Volver a la pagina principal
            </button>
          </form>
          <div
            class="alert alert-info alert-dismissible fade show"
            *ngIf="infoVisible"
          >
            <button
              type="button"
              aria-hidden="true"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
              (click)="infoVisible = false"
            >
              <i class="nc-icon nc-simple-remove"></i>
            </button>
            <span>
              <b> Aviso - </b> Su usuario es {{ userName }} y su contraseña ha
              sido enviada a su correo.</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
